import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {DocumentHal} from '../../models/HAL/document-hal.model';
import {HttpClient} from '@angular/common/http';
import {SafePipe} from '../../pipes/safe.pipe';
import {ActivatedRoute} from '@angular/router';
import {LoadingSpinnerService} from '../../services/loading-spinner.service';
import {ViewContextEnum} from '../../enums/view-context.enum';
import {PostMessageService} from '../../services/post-message.service';
import {CollaboratorHelperService} from '../../services/collaborator-helper.service';

import {LanguageEnum, LANGUAGE_STORAGE_KEY} from '../../enums/language.enum';
import {TranslatorService} from '../../services/translator.service';

@Component({
  selector: 'app-preview-form',
  imports: [
    SafePipe
  ],
  templateUrl: './preview-form.component.html',
  styleUrl: './preview-form.component.scss'
})
export class PreviewFormComponent implements OnInit, OnDestroy {

  @Input()
  document: DocumentHal | undefined;

  protected formUrl: string | undefined;
  private readonly hideSpinnerTimeout?: ReturnType<typeof setTimeout>;
  private iframeLoadedCounter: number = 0;


  constructor(
    private readonly httpClient: HttpClient,
    private readonly activatedRoute: ActivatedRoute,
    private readonly loadingSpinnerService: LoadingSpinnerService,
    private readonly postMessageService: PostMessageService,
    private readonly collaboratorHelperService: CollaboratorHelperService,
    private readonly translatorService: TranslatorService) {
    loadingSpinnerService.show();
    // Failsafe to hide spinner after 10 seconds
    this.hideSpinnerTimeout = setTimeout(() => {
      loadingSpinnerService.hide();
    }, 10000);
  }

  ngOnInit() {
    this.httpClient.get<{
      redirectUrl: string
    }>(new DocumentHal(this.document)._links.getLink("formUrl")!.href).subscribe(formUrl => {
      let url: URL = new URL(formUrl.redirectUrl);
      url.searchParams.set("caseId", this.activatedRoute.snapshot.params['caseId']);
      url.searchParams.set("documentId", this.document?.identification!);
      let lang = localStorage.getItem(LANGUAGE_STORAGE_KEY);
      lang ??= LanguageEnum.EN;
      let aemLang = this.translatorService.getAemLanguageKey(lang as LanguageEnum);
      url.searchParams.set("afAcceptLang", aemLang);
      this.formUrl = url.href;
    });
  }

  ngOnDestroy() {
    if (this.hideSpinnerTimeout) {
      clearTimeout(this.hideSpinnerTimeout);
    }
  }

  iframeLoaded() {
    const viewContext = this.collaboratorHelperService.isCollaboratorView ? ViewContextEnum.CUSTOMER : ViewContextEnum.BACKOFFICE;
    this.iframeLoadedCounter++;
    if (this.iframeLoadedCounter >= 2) {
      this.loadingSpinnerService.hide();
      this.postMessageService.postMessage(document.querySelector("#formPreview") as HTMLIFrameElement, this.postMessageService.getUserContextPostMessageModel(viewContext))
    }
  }
}
